/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  identityApiRef,
  fetchApiRef
} from '@backstage/core-plugin-api';
import type { OAuthApi, OpenIdConnectApi, ProfileInfoApi, BackstageIdentityApi, SessionApi } from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { searchApiRef } from '@backstage/plugin-search-react';
import { TenantAwareSearchClient } from './TenantAwareSearchClient';
import {
  githubActionsApiRef,
} from '@backstage/plugin-github-actions';
import { TenantAwareGithubActionsClient } from './apis/TenantAwareGithubActionsClient';

export const myOidcAuthApiRef = createApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.my-oidc-provider',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: myOidcAuthApiRef,
    deps: { discoveryApi: discoveryApiRef, oauthRequestApi: oauthRequestApiRef, configApi: configApiRef },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        provider: {
          id: 'my-oidc-provider',
          title: 'Cognito',
          icon: () => null,
        },
        defaultScopes: ['openid', 'email'],
        environment: configApi.getOptionalString('auth.environment'),
      }),
  }),
  
  createApiFactory({
    api: searchApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, fetchApi, identityApi }) =>
      new TenantAwareSearchClient({ discoveryApi, fetchApi, identityApi }),
  }),

  createApiFactory({
    api: githubActionsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) =>
      new TenantAwareGithubActionsClient({ configApi, identityApi }),
  }),
  
];
